import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { useState } from 'react';
import Button from './Button';

interface Props {
  htmlId?: string;
  text: string;
  onClick: (formData: FormData) => void;
  onError: (error: string) => void;
  className?: string;
  disabled?: boolean;
  icon?: string;
  title?: string;
  btnClass?: string;
  wrapperId?: string;
  style?: React.CSSProperties;
  formData: FormData;
}

const MaxSize = 30 * 1024 * 1024;

const FileUploadButtonMultiple: React.FC<Props> = ({
  htmlId,
  text,
  onClick,
  onError,
  className,
  disabled = false,
  icon,
  title,
  btnClass,
  wrapperId,
  style,
  formData,
}) => {
  const [prevFormData, setPrevFormData] = useState(formData);

  const upload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files || null;
    if (files == null || files.length < 0) {
      return;
    }

    let oversize = false;

    Array.from(files).forEach((ele) => {
      if (ele.size > MaxSize) {
        onError('oversize');
        oversize = true;
      }
    });

    if (!oversize) {
      const prevFiles = prevFormData.getAll('files');
      for (let i = 0; i < prevFiles.length; i += 1) {
        formData.append('files', prevFiles[i]);
      }

      for (let i = 0; i < files.length; i += 1) {
        formData.append('files', files[i]);
      }

      setPrevFormData(formData);

      e.target.value = '';
      onClick(formData);
    }
  };

  // eslint-disable-next-line no-unneeded-ternary

  return (
    <div className={`upload-btn-wrapper ${className}`} id={wrapperId}>
      <Button
        htmlId={htmlId}
        text={text}
        icon={(icon as IconProp) || 'arrow-circle-up'}
        className={`btn-tertiary ${btnClass}`}
        disabled={disabled}
        title={title}
        style={style}
      />
      <input type="file" multiple onChange={upload} disabled={disabled} />
    </div>
  );
};

export default FileUploadButtonMultiple;
